/**
 * 損失率を小数 1 桁の表示文字列へ整形する (AC-MLR-006)。
 * 0 は「0.0」になる (「0」や空表示にしない)。
 */
export function formatLossRate(value: number): string {
  return value.toFixed(1)
}
